import type { Projection } from '@v2/sdk'

export type TurnSnapshot = Pick<Projection, 'viewer' | 'activePlayer' | 'revision' | 'outcome'>
export function isYourTurn(projection: TurnSnapshot): boolean {
  return !!projection.viewer && projection.viewer === projection.activePlayer && !projection.outcome
}
/** Joining, changing seats, history traversal and repeated room updates stay quiet. */
export function startsYourTurn(previous: TurnSnapshot | null, next: TurnSnapshot): boolean {
  return !!previous && previous.viewer === next.viewer && next.revision > previous.revision
    && !isYourTurn(previous) && isYourTurn(next)
}
